export default __webpack_public_path__ + "static/media/table3seatUnilateral.bdd5d355.svg";